import { ExitType } from '../types.js';
import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
/** @deprecated */
export default class ExecArgCreatePerpGridStrategy extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgCreatePerpGridStrategy(params);
    }
    toData() {
        const { params } = this;
        return {
            subaccount_id: params.subaccountId,
            bounds: [params.lowerBound, params.upperBound],
            levels: params.levels,
            slippage: params.slippage,
            strategy_type: {
                perpetual: {
                    margin_ratio: params.marginRatio,
                },
            },
            stop_loss: params.stopLoss
                ? {
                    exit_type: ExitType.Default,
                    exit_price: params.stopLoss,
                }
                : undefined,
            take_profit: params.takeProfit
                ? {
                    exit_type: ExitType.Default,
                    exit_price: params.takeProfit,
                }
                : undefined,
            ...(params.feeRecipient && {
                fee_recipient: params.feeRecipient,
            }),
        };
    }
    toExecData() {
        return dataToExecData('create_strategy', this.toData());
    }
}
